@let formValue = form();
@let parentCategoriesValue = parentCategories();
@let currentSubcategoriesValue = currentSubcategories();

<div [formGroup]="formValue">
    <div class="card-text">
        <div class="row">
            <div class="col-sm-2 bolded">{{ 'CampCreate.Category' | translate }}</div>
            @if (parentCategoriesValue) {
                <div class="col-sm-10">
                    @for (parentCategory of parentCategoriesValue; track $index) {
                        <div class="categories">
                            <div class="category" hznTestId="camp-category-parent" [ngClass]="{ selected: isSelectedParent(parentCategory) }" (click)="selectParent(parentCategory)">
                                <div class="col-md-auto">
                                    <!-- <app-camp-icon [iconName]="parentCategory.iconName" [size]="30"></app-camp-icon> -->
                                </div>
                                <div class="col">
                                    {{ parentCategory.name }}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }

            @if (currentSubcategoriesValue.length > 0) {
                <div class="col-sm-2 bolded mt-3">{{ 'CampCreate.Subcategory' | translate }}</div>
                <div class="col-sm-10 mt-3">
                    @for (subcategory of currentSubcategoriesValue; track $index) {
                        <div class="category subcategory" hznTestId="camp-category-subcategory" [ngClass]="{ selected: isSelected(subcategory) }" (click)="selectSubcategory(subcategory)">
                            <div class="col-md-auto">
                                <!-- <app-camp-icon [iconName]="subcategory.iconName" [size]="25"></app-camp-icon> -->
                            </div>
                            <div class="col">
                                {{ subcategory.name }}
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>
